import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import { dictionaryFieldTypes, fieldTypeName } from '@/constants/fields';

const itemValue = (typeOrConstraint, isConstraint = false) => (
  isConstraint ? `lkp:${typeOrConstraint}` : `type:${typeOrConstraint}`
);

const filterItems = (filter, items) => (
  filter ? items.filter((item) => item.props.value.toLowerCase().includes(filter)) : items
);

const typeItems = (intl, currentValue, filter, onClick) => {
  const items = (Object.values(dictionaryFieldTypes).map((type) => {
    const value = itemValue(type);
    return (
      <Dropdown.Item
        key={`dictionary_simple_type_${type}`}
        value={value}
        active={currentValue === value}
        selected={currentValue === value}
        onClick={() => onClick(type)}
        text={intl.formatMessage({ id: fieldTypeName(type) })}
      />
    );
  }));

  return filterItems(filter, items);
};

const lookupItems = (intl, lookups, currentValue, filter, onClick) => {
  const lookupKeys = Object.keys(lookups).sort();
  const items = lookupKeys.map((key) => {
    const value = itemValue(key, true);
    return (
      <Dropdown.Item
        key={`dictionary_lookup_${key}`}
        value={value}
        active={currentValue === value}
        selected={currentValue === value}
        text={key}
        onClick={() => onClick(key)}
        description={intl.formatMessage({ id: fieldTypeName(lookups[key].type) })}
      />
    );
  });

  return filterItems(filter, items);
};

const DictionaryFieldTypeDropdown = ({
  onTypeChange,
  onConstraintChange,
  type,
  constraint,
  lookups,
}) => {
  const intl = useIntl();
  const [filter, setFilter] = useState('');

  const onSearchChange = (value) => (setFilter(value.toLowerCase()));
  const onTypeClick = (value) => {
    setFilter('');
    onTypeChange(value);
  };
  const onConstraintClick = (value) => {
    setFilter('');
    onConstraintChange(value);
  };

  const currentValue = lookups[constraint] ? itemValue(constraint, true) : itemValue(type);
  const currentText = lookups[constraint] ? constraint : intl.formatMessage({ id: fieldTypeName(type) });
  const lookupComponents = lookupItems(intl, lookups, currentValue, filter, onConstraintClick);

  return (
    <Dropdown
      className="aridhia-dictionary-field-type-dropdown selection aridhia-is-edit-mode"
      placeholder={intl.formatMessage({ id: 'dataset.dictionary.field.type.placeholder' })}
      text={currentText}
      value={currentValue}
      fluid
      onSearchChange={(e, { searchQuery }) => onSearchChange(searchQuery)}
    >
      <Dropdown.Menu>
        {typeItems(intl, currentValue, filter, onTypeClick)}
        {lookupComponents.length > 0 && (
          <>
            <Dropdown.Header
              icon="list"
              content={intl.formatMessage({ id: 'dataset.dictionary.field.type.lookups' })}
            />
            <Dropdown.Divider />
            {lookupComponents}
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DictionaryFieldTypeDropdown;
